// import 'bootstrap/dist/css/bootstrap.min.css';
// import React , { useState } from 'react';

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Home from './LandingPage/Home';
// import AdminDashboard from './pages/AdminHome';
// import Login from './pages/Auth/Login';
// import './assets/css/Sidebar.css'


// // Dashboard
// import Dashboard from './AdminPage/components/Dashboard';
// import DoctorDashboard from './DoctorPage/DoctorDashboard';
// import PatientDashboard from './AdminPage/components/Dashboard/PatientDashboard';

// // Appointments
// import Appointments from './AdminPage/components/Appointments';
// import AppointmentCalendar from './AdminPage/components/Appointments/AppointmentCalendar';
// import BookAppointment from './AdminPage/components/Appointments/BookAppointment';
// import EditAppointment from './AdminPage/components/Appointments/EditAppointment';
// import ViewAppointment from './AdminPage/components/Appointments/ViewAppointment';

// // Doctors
// import Doctor from './AdminPage/components/Doctors';
// import AddDoctor from './AdminPage/components/Doctors/AddDoctor';
// import AllDoctor from './AdminPage/components/Doctors/AllDoctors';
// import DoctorProfile from './AdminPage/components/Doctors/DoctorProfile';
// import EditDoctor from './AdminPage/components/Doctors/EditDoctor';
// import ShiftManagement from './AdminPage/components/Doctors/ShiftManagement';

// import AssignDepartment from './AdminPage/components/Doctors/AssignDeparment'

// // Staff
// import Staff from './AdminPage/components/Staff';
// import AddStaff from './AdminPage/components/Staff/AddStaff';
// import AllStaff from './AdminPage/components/Staff/AllStaff';
// import EditStaff from './AdminPage/components/Staff/EditStaff';
// import StaffProfile from './AdminPage/components/Staff/StaffProfile';

// // Patients
// import Patients from './AdminPage/components/Patients';
// import AddPatient from './AdminPage/components/Patients/AddPatient';
// import AllPatients from './AdminPage/components/Patients/AllPatients';
// import EditPatient from './AdminPage/components/Patients/EditPatient';
// import PatientProfile from './AdminPage/components/Patients/PatientProfile';
// import PatientRecords from './AdminPage/components/Patients/PatientRecords';

// // Accounts
// import Accounts from './AdminPage/components/Accounts';
// import AddBill from './AdminPage/components/Accounts/AddBill';
// import BillList from './AdminPage/components/Accounts/BillList';
// import Expenses from './AdminPage/components/Accounts/Expenses';
// import Income from './AdminPage/components/Accounts/Income';
// import IncomeReport from './AdminPage/components/Accounts/IncomeReport';
// import Invoice from './AdminPage/components/Accounts/Invoice';

// // Blood Bank 

// import BloodDonor from './AdminPage/components/BloodBank/BloodDonor'
// import BloodIssued from './AdminPage/components/BloodBank/BloodIssued'
// import BloodStock from './AdminPage/components/BloodBank/BloodStock'

// //Add Department

// import AddDepartment from './AdminPage/components/Departments/AddDepartment'
// import DepartmentList from './AdminPage/components/Departments/DepartmentList'


// // Human Resources

// import HumanResources from './AdminPage/components/HumanResources'
// import AttendanceSheet from './AdminPage/components/HumanResources/AttendanceSheet'
// import EmployeeAttendance from './AdminPage/components/HumanResources/EmployeeAttendance'
// import EmployeeSalary from './AdminPage/components/HumanResources/EmployeeSalary'
// import Holiday from './AdminPage/components/HumanResources/Holiday'
// import LeaveBalance from './AdminPage/components/HumanResources/LeaveBalance'
// import LeaveRequests from './AdminPage/components/HumanResources/LeaveRequests'
// import LeaveTypes from './AdminPage/components/HumanResources/LeaveTypes'
// import Payslip from './AdminPage/components/HumanResources/Payslip'
// import TodaysAttendance from './AdminPage/components/HumanResources/TodaysAttendance'


// //Insurance

// import ClaimStatus from './AdminPage/components/Insurance/ClaimStatus'
// import InsuranceProvider from './AdminPage/components/Insurance/InsuranceProvider'
// import NewClaim from './AdminPage/components/Insurance/NewClaim'
// import PatientInsurance from './AdminPage/components/Insurance/PatientInsurance'


// // Inventory
// import Inventory from './AdminPage/components/Inventory/index'
// import IssuedItems from './AdminPage/components/Inventory/IssuedItems';
// import ItemStockList from './AdminPage/components/Inventory/ItenStockList';


// // Records
// import Records from './AdminPage/components/Records/index'
// import BirthRecords from './AdminPage/components/Records/BirthRecords';
// import DeathRecords from './AdminPage/components/Records/DeathRecords';


// // Pharmacy
// import Pharmacy from './AdminPage/components/Pharmacy/index'

// import AddMedicine from './AdminPage/components/Pharmacy/AddMedicine';
// import MedicineList from './AdminPage/components/Pharmacy/MedicineList';

// // roles
// import Roles from './AdminPage/components/Roles/roles'
// import DoctorSchedule from './AdminPage/components/DoctorSchedule/DoctorSchedule'
// import DoctorScheduleCreate from './AdminPage/components/DoctorSchedule/Create'


// // Ambulance
// import Ambulance from './AdminPage/components/Ambulance/index'
// import AmbulanceCallList from './AdminPage/components/Ambulance/AmbulanceCallList'
// import AmbulanceList from './AdminPage/components/Ambulance/AmbulanceList'


// import './App.css'; // Importing the CSS file
// import AssignDeparment from './AdminPage/components/Doctors/AssignDeparment';
// import LandingLayout from './LandingPage/LandingLayout';
// import AdminLayout from './AdminPage/AdminLayout/AdminLayout';
// import DoctorLayout from './DoctorPage/DoctorLayout/DoctorLayout'
// function App() {

//   const [isSidebarOpen, setSidebarOpen] = useState(true);
//   return (
    
//     <Router>
//       <Routes>
//       <Route element={<LandingLayout />}>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//         </Route>
//         </Routes>
//           <Routes>
//           <Route element={<AdminLayout />}>
//           <Route path="/admin/home" element={<AdminDashboard/>} >
//           <Route path="staff/all_staff" element={<AllStaff />} />
//           <Route path="staff" element={<Staff />} />
//           <Route path="staff/add_staff" element={<AddStaff />} />
//           <Route path="staff/edit_staff" element={<EditStaff />} />
//           <Route path="staff/staff_profile" element={<StaffProfile />} />
//           <Route path="roles" element={<Roles />} />
//           <Route path="inventory" element={<Inventory />} /> 
          
//             <Route path="/admin/home/appointments/view_appointment" element={<ViewAppointment />} />
           
//             <Route path="dashboard" element={<Dashboard />}>
//             <Route path="admin_dashboard" element={<AdminDashboard/>}/>
          
//             <Route path="patient_dashboard" element={<PatientDashboard />} />
//             <Route path="appointments" element={<Appointments />}>
//             <Route path="appointment_calendar" element={<AppointmentCalendar />} />
//                 {/* <Route path="view_appointment" element={<ViewAppointment />} /> */}
//             <Route path="book_appointment" element={<BookAppointment />} />
//             <Route path="edit_appointment" element={<EditAppointment />} />
//             <Route path="doctors" element={<Doctor />}>
//                 <Route path="all_doctors" element={<AllDoctor />} />
//                 <Route path="add_doctor" element={<AddDoctor />} />
//                 <Route path="edit_doctor" element={<EditDoctor />} />
//                 <Route path="assign_department" element={<AssignDepartment />} />
//                 <Route path="shift_management" element={<ShiftManagement />} />
//                 <Route path="doctor_profile" element={<DoctorProfile />} />
//               </Route>
//               <Route path="patients" element={<Patients />}>
//                 <Route path="all_patients" element={<AllPatients />} />
//                 <Route path="add_patient" element={<AddPatient />} />
//                 <Route path="edit_patient" element={<EditPatient />} />
//                 <Route path="patient_records" element={<PatientRecords />} />
//                 <Route path="patient_profile" element={<PatientProfile />} />
//               </Route>

//               <Route path="accounts" element={<Accounts />}>
//                 <Route path="bill_list" element={<BillList />} />
//                 <Route path="add_bill" element={<AddBill />} />
//                 <Route path="income" element={<Income />} />
//                 <Route path="expenses" element={<Expenses />} />
//                 <Route path="income_report" element={<IncomeReport />} />
//                 <Route path="invoice" element={<Invoice />} />
//               </Route>
//             </Route>

//             </Route>

//               <Route path="human_resources" element={<HumanResources />}>
//                 <Route path="attendance_sheet" element={<AttendanceSheet />} />
//                 <Route path="employee_attendance" element={<EmployeeAttendance/>} />
//                 <Route path="employee_salary" element={<EmployeeSalary />} />
//                 <Route path="holiday" element={<Holiday />} />
//                 <Route path="leave_balance" element={<LeaveBalance />} />
//                 <Route path="leave_requests" element={<LeaveRequests/>} />
//                 <Route path="leave_types" element={<LeaveTypes/>} />
//                 <Route path="payslip" element={<Payslip />} />
//                 <Route path="todays_attendance" element={<TodaysAttendance />} />
//               </Route>
//             </Route>
//             </Route>

//             <Route element={<DoctorLayout/>}>
//             <Route path="/doctor/home" element={<DoctorDashboard />} />
//             <Route path="/home/pharmacy" element={<Pharmacy/>} /> 
//             <Route path="/home/doctor_schedule" element={<DoctorSchedule/>} /> 
//             <Route path="/home/doctor_schedule_create" element={<DoctorScheduleCreate/>} /> 
//             </Route>
//           </Routes>
       
     
//     </Router>
//   );
// }

// export default App;


import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layouts
import LandingLayout from './LandingPage/LandingLayout';
import AdminLayout from './AdminPage/AdminLayout/AdminLayout';
import DoctorLayout from './DoctorPage/DoctorLayout/DoctorLayout';

// Landing Pages
import Home from './LandingPage/Home';
import Login from './pages/Auth/Login';

// Dashboards
import AdminDashboard from './pages/AdminHome';
import Dashboard from './AdminPage/components/Dashboard';
import DoctorDashboard from './DoctorPage/DoctorDashboard';
import PatientDashboard from './AdminPage/components/Dashboard/PatientDashboard';

// Staff
import Staff from './AdminPage/components/Staff';
import AllStaff from './AdminPage/components/Staff/AllStaff';
import AddStaff from './AdminPage/components/Staff/AddStaff';
import EditStaff from './AdminPage/components/Staff/EditStaff';
import StaffProfile from './AdminPage/components/Staff/StaffProfile';

// Roles
import Roles from './AdminPage/components/Roles/roles';

// Inventory
import Inventory from './AdminPage/components/Inventory/index';

// Appointments
import Appointments from './AdminPage/components/Appointments';
import AppointmentCalendar from './AdminPage/components/Appointments/AppointmentCalendar';
import BookAppointment from './AdminPage/components/Appointments/BookAppointment';
import EditAppointment from './AdminPage/components/Appointments/EditAppointment';
import ViewAppointment from './AdminPage/components/Appointments/ViewAppointment';

// Doctors
import Doctor from './AdminPage/components/Doctors';
import AddDoctor from './AdminPage/components/Doctors/AddDoctor';
import AllDoctor from './AdminPage/components/Doctors/AllDoctors';
import DoctorProfile from './AdminPage/components/Doctors/DoctorProfile';
import EditDoctor from './AdminPage/components/Doctors/EditDoctor';
import ShiftManagement from './AdminPage/components/Doctors/ShiftManagement';
import AssignDepartment from './AdminPage/components/Doctors/AssignDeparment';

// Patients
import Patients from './AdminPage/components/Patients';
import AddPatient from './AdminPage/components/Patients/AddPatient';
import AllPatients from './AdminPage/components/Patients/AllPatients';
import EditPatient from './AdminPage/components/Patients/EditPatient';
import PatientProfile from './AdminPage/components/Patients/PatientProfile';
import PatientRecords from './AdminPage/components/Patients/PatientRecords';
import PatientHistory from './AdminPage/AdminLayout/PatientHistory';
import AdminPrescription from './AdminPage/AdminLayout/Prescription';

// Accounts
import Accounts from './AdminPage/components/Accounts';
import AddBill from './AdminPage/components/Accounts/AddBill';
import BillList from './AdminPage/components/Accounts/BillList';
import Expenses from './AdminPage/components/Accounts/Expenses';
import Income from './AdminPage/components/Accounts/Income';
import IncomeReport from './AdminPage/components/Accounts/IncomeReport';
import Invoice from './AdminPage/components/Accounts/Invoice';

// Human Resources
import HumanResources from './AdminPage/components/HumanResources';
import AttendanceSheet from './AdminPage/components/HumanResources/AttendanceSheet';
import EmployeeAttendance from './AdminPage/components/HumanResources/EmployeeAttendance';
import EmployeeSalary from './AdminPage/components/HumanResources/EmployeeSalary';
import Holiday from './AdminPage/components/HumanResources/Holiday';
import LeaveBalance from './AdminPage/components/HumanResources/LeaveBalance';
import LeaveRequests from './AdminPage/components/HumanResources/LeaveRequests';
import LeaveTypes from './AdminPage/components/HumanResources/LeaveTypes';
import Payslip from './AdminPage/components/HumanResources/Payslip';
import TodaysAttendance from './AdminPage/components/HumanResources/TodaysAttendance';

// Doctor Routes
import Pharmacy from './AdminPage/components/Pharmacy';
import PharmacyPage from './DoctorPage/Pharmacy';
import DoctorSchedule from './AdminPage/components/DoctorSchedule/DoctorSchedule';
import DoctorScheduleCreate from './AdminPage/components/DoctorSchedule/Create';
import AddMedicine from './AdminPage/components/Medicine/AddMedicine';
import MedicineList from './AdminPage/components/Medicine/MedicineList';
import EditMedicine from './AdminPage/components/Medicine/EditMedicine';
import DoctorSlotChecker from './DoctorPage/DoctorSlotChecker';
import ViewSlots from './AdminPage/components/DoctorSchedule/ViewSlots'
import ViewAppointments from './DoctorPage/ViewAppointment'

import ReceptionistLayout from './Receptionist/Layout/ReceptionistLayout';
import RecptionistDashboard  from './Receptionist/Dashboard';
import AddPatientRecptionist from './Receptionist/AddPatient';
import EditPatientRecptionist from './Receptionist/EditPatient';
import PatientDetails from './Receptionist/PatientDetails';
import AppointmentCreate from './Receptionist/AppointmentCreate';
import AppointmentList from './Receptionist/AppointmentList';
import Billing from './Receptionist/Billing';
import PharmacyBilling from './Receptionist/PharmacyBilling'

import './App.css';
import InvoiceListPage from './DoctorPage/InvoiveListPage';
import BookAppointmentPage from './LandingPage/BookAppointmentPage';
import AppWrapper from './AppWrapper';
import PatientListPage from './DoctorPage/PatientsList';
import PatientListIdPage from './DoctorPage/PatientIdList';
import DoctorAppointmentList from './DoctorPage/AppointmentList'


// Receptionist
import Prescription from './Receptionist/Prescription';
import DoctorInventory from './DoctorPage/Inventory/index'
import AddInventory from './DoctorPage/Inventory/ItenStockList'
import InventoryList from './DoctorPage/Inventory'
import EditInventory from './DoctorPage/Inventory'
import PrescriptionPreview from './Receptionist/PrescriptionPreview';
import PrescriptionPrint from './Receptionist/PrescriptionPrint';
import CalendarPage from './DoctorPage/CalendarPage';
import PatientHistoryPage from './DoctorPage/PatientHistoryPage';
import PrescriptionsPage from './DoctorPage/PrescriptionsPage';
import DoctorBookingListPage from './DoctorPage/DoctorBookingListPage';
import InventoryStock from './AdminPage/components/Inventory/InventoryStock'
import InventoryTansaction from './AdminPage/components/Inventory/InventoryTansaction'


function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Pages */}
        <Route element={<LandingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/appointment" element={<BookAppointmentPage />} />
          
        </Route>

        {/* Admin Dashboard Routes */}
        <Route path="/admin/home" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="patient_dashboard" element={<PatientDashboard />} />

          {/* Staff */}
          <Route path="staff" element={<Staff />} />
          <Route path="staff/all_staff" element={<AllStaff />} />
          <Route path="staff/add_staff" element={<AddStaff />} />
          <Route path="staff/edit_staff" element={<EditStaff />} />
          <Route path="staff/staff_profile" element={<StaffProfile />} />

          {/* Roles */}
          <Route path="roles" element={<Roles />} />

          {/* Inventory */}
          <Route path="inventory" element={<Inventory />} />
          <Route path="medicines/add" element={<AddMedicine />} />
          <Route path="medicines/list" element={<MedicineList />} />
          <Route path="medicines/edit/:id" element={<EditMedicine />} />
          <Route path="medicines/stock/:medicineId" element={<InventoryStock />} />
           <Route path="medicines/transaction/:medicineId" element={<InventoryTansaction />} />


          {/* Inventory */}
          <Route path="pharmacy" element={<Inventory />} />
          <Route path="pharmacy/add" element={<AddMedicine />} />
          <Route path="pharmacy/list" element={<MedicineList />} />
          <Route path="pharmacy/edit/:id" element={<EditMedicine />} />


          

          {/* Appointments */}
          <Route path="appointments" element={<Appointments />} />
          <Route path="appointments/appointment_calendar" element={<AppointmentCalendar />} />
          <Route path="appointments/book_appointment" element={<BookAppointment />} />
          <Route path="appointments/edit_appointment" element={<EditAppointment />} />
          <Route path="appointments/view_appointment" element={<ViewAppointment />} />

          <Route path="doctor_schedule" element={<DoctorSchedule />} />
          <Route path="doctor_schedule_create" element={<DoctorScheduleCreate />} />
          <Route path="doctor_schedule/:scheduleId/slots" element={<ViewSlots />} />

          {/* Doctors */}
          <Route path="doctors" element={<Doctor />} />
          <Route path="doctors/all_doctors" element={<AllDoctor />} />
          <Route path="doctors/add_doctor" element={<AddDoctor />} />
          <Route path="doctors/edit_doctor" element={<EditDoctor />} />
          <Route path="doctors/assign_department" element={<AssignDepartment />} />
          <Route path="doctors/shift_management" element={<ShiftManagement />} />
          <Route path="doctors/doctor_profile" element={<DoctorProfile />} />

          {/* Patients */}

 <Route path="patients/:patientId" element={<PatientHistory />} />
  <Route path="patients/:patientId/prescriptions" element={<AdminPrescription />} />
        



          <Route path="patients" element={<AllPatients />} />
          <Route path="patients/all_patients" element={<Patients />} />
          <Route path="patients/add_patient" element={<AddPatient />} />
          <Route path="patients/edit_patient" element={<EditPatient />} />
          <Route path="patients/patient_profile" element={<PatientProfile />} />
          <Route path="patients/patient_records" element={<PatientRecords />} />

          {/* Accounts */}
          <Route path="accounts" element={<Accounts />} />
          <Route path="accounts/add_bill" element={<AddBill />} />
          <Route path="accounts/bill_list" element={<BillList />} />
          <Route path="accounts/income" element={<Income />} />
          <Route path="accounts/expenses" element={<Expenses />} />
          <Route path="accounts/income_report" element={<IncomeReport />} />
          <Route path="accounts/invoice" element={<Invoice />} />

          {/* Human Resources */}
          <Route path="human_resources" element={<HumanResources />} />
          <Route path="human_resources/attendance_sheet" element={<AttendanceSheet />} />
          <Route path="human_resources/employee_attendance" element={<EmployeeAttendance />} />
          <Route path="human_resources/employee_salary" element={<EmployeeSalary />} />
          <Route path="human_resources/holiday" element={<Holiday />} />
          <Route path="human_resources/leave_balance" element={<LeaveBalance />} />
          <Route path="human_resources/leave_requests" element={<LeaveRequests />} />
          <Route path="human_resources/leave_types" element={<LeaveTypes />} />
          <Route path="human_resources/payslip" element={<Payslip />} />
          <Route path="human_resources/todays_attendance" element={<TodaysAttendance />} />
        </Route>

        {/* Doctor Dashboard Routes */}
        <Route path="/doctor/home" element={<DoctorLayout />}>

      
      <Route index element={<DoctorDashboard />} />
      
      <Route path="calendar" element={<CalendarPage />} />
          <Route path="view-appointment/:appointmentId" element={<ViewAppointments />} />
      <Route path="patients" element={<PatientHistoryPage />} />
      <Route path="prescriptions" element={<PrescriptionsPage />} />
      <Route path="pharmacy" element={<PharmacyPage />} />
      <Route path="check-slots" element={<DoctorSlotChecker />} />
      <Route path="bookings" element={<DoctorBookingListPage />} />
      <Route path="appointments-list" element={<DoctorAppointmentList />} />
      <Route path="invoice-list" element={<InvoiceListPage />} />
      <Route path="patients-list" element={<PatientListPage />} />
      <Route path="patients/:patientId" element={<PatientListIdPage />} />
      <Route path="patients/:patientId/prescriptions" element={<PrescriptionsPage />} />
        <Route path="inventory" element={<DoctorInventory />} />
          <Route path="inventory/add" element={<AddInventory />} />
          <Route path="inventory/list" element={<InventoryList />} />
          <Route path="inventory/edit/:id" element={<EditInventory />} />

          <Route path="check-slots" element={<DoctorSlotChecker />} />
        </Route>

        <Route path="/receptionist/home" element={<ReceptionistLayout />}>
          <Route index element={<RecptionistDashboard />} />
          <Route path="patients/new" element={<AddPatientRecptionist />} />
          <Route path="patients/edit/:id" element={<EditPatientRecptionist />} />
          
          <Route path="patients/details/:id" element={<PatientDetails />} />
          <Route path="appointments" element={<AppointmentList />} />
          <Route path="appointments/new" element={<AppointmentCreate />} />
          <Route path="appointments/new" element={<AppointmentCreate />} />
          <Route path="appointments/prescription/:patientId" element={<Prescription />} />
          <Route path="prescription/preview/:patientId" element={<PrescriptionPreview />} />
          <Route path="prescription/print/:patientId" element={<PrescriptionPrint />} />
           <Route path="appointments/new" element={<AppointmentCreate />} />

        </Route>

        <Route path="/receptionist/home" element={<ReceptionistLayout />}>
          <Route index element={<RecptionistDashboard />} />
          <Route path="patients/new" element={<AddPatientRecptionist />} />
          <Route path="patients/edit/:id" element={<EditPatientRecptionist />} />
          <Route path="patients/details/:id" element={<PatientDetails />} />
          <Route path="appointments" element={<AppointmentList />} />
          <Route path="billing/list" element={<Billing />} />   
          <Route path="pharmacy-billing" element={<PharmacyBilling />} />                  
        </Route>
      </Routes>
<AppWrapper/>
    </Router>
  );
}

export default App;


